import { ProDetailList, ProText } from '@bedrock/eed-react';
import { FormCard, FormModule, SupplierDetailList } from '@purchase/supplier';
import React, { useMemo } from 'react';
import { get } from 'lodash-es';
import { ProTextEllipsis } from '../../components/ProTextEllipsis';

export const TeamProfessional = (props: {
  namePath?: string[];
  mode?: 'card' | 'module';
  formItemProps?: any;
  formDetail?: any;
}) => {
  const { namePath = [], mode = 'module', formItemProps, formDetail } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;
  const teamCount = useMemo(
    () =>
      get(formDetail, [...namePath, 'extendAttributeInfo', 'teamProfessional'])
        ?.length ?? 0,
    [formDetail, namePath]
  );
  return (
    <Wrapper
      title="团队专业度"
      titleCount={teamCount}
      proCardProps={{ expandable: true, defaultExpanded: teamCount > 0 }}
    >
      <SupplierDetailList
        name={[...namePath, 'extendAttributeInfo', 'teamProfessional']}
        fieldProps={{ scroll: { x: 1120 } }}
        formItemProps={formItemProps}
      >
        <ProDetailList.Item
          label="#"
          name="#"
          meta={{ columnProps: { width: 50, fixed: true } }}
        >
          {(value, record, index) => {
            return index + 1;
          }}
        </ProDetailList.Item>
        <ProDetailList.Item
          label="核心人员姓名"
          name="corePersonnel"
          meta={{
            columnProps: { width: 200, className: 'font-bold', fixed: true },
          }}
        >
          <ProText />
        </ProDetailList.Item>
        <ProDetailList.Item
          label="所属部门"
          name="ownDepartment"
          meta={{ columnProps: { width: 160 } }}
        >
          <ProText />
        </ProDetailList.Item>
        <ProDetailList.Item
          label="职务/岗位"
          name="positionPost"
          meta={{ columnProps: { width: 160 } }}
        >
          <ProText />
        </ProDetailList.Item>
        <ProDetailList.Item label="主要负责内容" name="mainResponsibilities">
          <ProTextEllipsis />
        </ProDetailList.Item>
        <ProDetailList.Item
          label="垂直行业经验"
          name="verticalIndustryExperience"
        >
          <ProTextEllipsis />
        </ProDetailList.Item>
      </SupplierDetailList>
    </Wrapper>
  );
};
